import React from 'react';
import Header from '../../components/Header/Header';
import ContactForm from '../../components/ContactForm/ContactForm';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <SEO
        title="Contact Unimar — Get in Touch"
        description="Contact the Unimar team for inquiries about our fiberglass boats, pricing, delivery, or dealer partnerships. Based in North Macedonia, serving Europe and the Balkans."
        url="/contact"
      />
      <Header />
      <div className="contact-page__hero">
        <img src="/unimar-contact-banner.webp" alt="Unimar Boats" className="contact-page__hero-img" />
      </div>
      <ContactForm white />
      <Footer />
    </div>
  );
}

export default Contact;
